import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import BBIconNetworkGlobe from "../../../assets/bbCustomIcons/BBIconNetworkGlobe";
import {bbDoesCustomerHaveAccessToSubscriptionLevel, bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import { HashLink as Link } from 'react-router-hash-link';


const Tile = ({
                summaryDataBranch = "severity",
                  varName = "high",
    subTitle = "",
    tipText = "",
    icon = null,
    linkOverridePathnameHash = null, //{pathname:`/board/BreachRisk/Business/Report/Overview`, hash:`threatsSummaryTable`}
              }) => {

    // const {customerId} = props;

    // const summaryDataVarName = varName;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers && customerIdToUse ? customers[customerIdToUse] : null;

    const hasFreeSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 10);
    const hasLiteSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 6);
    const hasProSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 7);
    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);

    const widgetLink = linkOverridePathnameHash ? linkOverridePathnameHash : hasLiteSubscription
    || hasProSubscription
    || hasPremiumSubscription
        ? {pathname:`/board/BreachRisk/Business/Report/TechData`, hash: 'tourStepBRReportVectorsTable'}
        : {pathname:`/board/BreachRisk/Business/Report/Overview`, hash:`threatsSummaryTable`}

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const vectorSummaryData = myEntity
    && myEntity.last_cycle
    // && myEntity.last_cycle.cycle
    && myEntity.last_cycle.vector_summary
    // && myEntity.cycles
    // && myEntity.cycles[myEntity.last_cycle.cycle]
    // && myEntity.cycles[myEntity.last_cycle.cycle].summary
    // && myEntity.cycles[myEntity.last_cycle.cycle].summary.vector_summary
    // && myEntity.cycles[myEntity.last_cycle.cycle].summary.vector_summary[`${summaryDataBranch}`]
    && myEntity.last_cycle.vector_summary[`${summaryDataBranch}`]
        ? myEntity.last_cycle.vector_summary[`${summaryDataBranch}`]
        : null;

    // console.log("New data tile branch widget. Looking for summaryDataBranch", summaryDataBranch, "and varName of", varName, "found this:", vectorSummaryData);

    const colorFunction = (stateData) => {
        const dataPointToDisplay = vectorSummaryData
            ?  vectorSummaryData[varName]
            : null;

        if(dataPointToDisplay && dataPointToDisplay > 0) {
            if(varName === "low") {
                return "bb-risk-low"
            } else if (varName === "medium") {
                return "bb-risk-medium"
            } else if (varName === "high") {
                return "bb-risk-high"
            } else {
                return "electric-blue"
            }

        } else {
            return "light";
        }

    }

    const valueFunction = (stateData) => {

        const dataPointToDisplay = vectorSummaryData
            ?  vectorSummaryData[varName]
            : null;

        return dataPointToDisplay;
    }


    return (
        <Link smooth to={widgetLink}>
            <DataTile
                // color = {colorFunction()}
                colorBgFunction={colorFunction}
                subTitle={subTitle}
                tipText={tipText}
                icon={icon}
                stateName="breachrisk"
                stateElement="portfolios"
                //useDeepDataStore
                // dontFetch
                forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && vectorSummaryData ? false : true}
                valueFunction={valueFunction}
                // ribbonFunction={null}
                // requiresModule={"monitor"}
            />
        </Link>
    )

}

export default Tile;